import React from 'react';
import { getStorefrontBrandName, getStorefrontLogoUrl } from '../../utils/storefrontBrand';

/**
 * Full-screen boot splash shown while the storefront loads.
 * Prefer company logo; fall back to static brand mark.
 */
const StorefrontBootSplash = ({ company = null, label = 'Yükleniyor...' }) => {
  const logoSrc = getStorefrontLogoUrl(company) || '/logo512.png';
  const brandName = getStorefrontBrandName(null, company);

  return (
    <div
      className="fixed inset-0 z-[9999] flex min-h-screen flex-col items-center justify-center bg-slate-50"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <img
        src={logoSrc}
        alt={brandName}
        className="mb-5 h-16 w-auto max-w-[220px] object-contain"
        width={220}
        height={64}
      />
      <div className="h-8 w-8 rounded-full border-2 border-slate-200 border-t-red-600 animate-spin" />
      <p className="mt-3 text-sm font-medium text-slate-500">{label}</p>
    </div>
  );
};

export default StorefrontBootSplash;
